export default __webpack_public_path__ + "static/media/Dog-swimming.8b3b94ca.png";